import React, { useMemo } from 'react';
import { Spinner } from 'reactstrap';
import OBarChart from '../../../../Components/OElements/OBarChart';
import { ECHARTS_COLOR_PALETTE } from '../../../../Components/Hooks/useColorArrayHooks';

const BreachByResponsibleAreaChart = ({ data, isLoading }) => {
	const chartData = Array.isArray(data) ? data : [];

	const options = useMemo(() => {
		const names = chartData.map(d => d.name || 'Sin datos');
		const values = chartData.map(d => d.count);

		return {
			color: ECHARTS_COLOR_PALETTE,
			tooltip: {
				trigger: 'axis',
				axisPointer: { type: 'shadow' },
			},
			grid: { left: '3%', right: '4%', bottom: '10%', top: '8%', containLabel: true },
			xAxis: {
				type: 'category',
				data: names,
				axisLabel: { rotate: 30, overflow: 'truncate', width: 80 },
			},
			yAxis: { type: 'value', name: 'Cantidad' },
			series: [
				{
					name: 'Incumplimientos',
					type: 'bar',
					data: values,
					barMaxWidth: 40,
					label: {
						show: true,
						position: 'top',
						formatter: ({ value }) => (value > 0 ? value : ''),
					},
				},
			],
		};
	}, [chartData]);

	if (isLoading) {
		return (
			<div className='d-flex justify-content-center align-items-center py-4'>
				<Spinner size='sm' />
			</div>
		);
	}

	if (!chartData.length) {
		return (
			<div className='d-flex flex-column align-items-center justify-content-center text-muted py-4 h-100'>
				<i className='ri-bar-chart-2-line fs-1 mb-2'></i>
				<p className='mb-0'>Sin datos disponibles</p>
			</div>
		);
	}

	return <OBarChart options={options} minHeight='280px' maxHeight='400px' />;
};

export default React.memo(BreachByResponsibleAreaChart);
